<div class="content-heading">
  <div class="header-container">
    <h3>Reporte de Altas y Bajas de Equipo</h3>
    <small>Reporte Web</small>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-default">
        <div class="card-body">
          <div id="RECSEG">
            <div class="row filter-container">
              <div class="col-sm-4">
                <span>Organizaci&oacute;n</span>
                 <aph-custom-select
                  type="organization"
                  [org]="user.Org.toString()"
                  [userId]="user.Id.toString()"
                  placeholder="-- Seleccione una opción --"
                  (onSelectionChange)="getRegion()"
                  [disabled]="working"
                  (returnValue)="organizationSelected = $event">
                </aph-custom-select>
              </div>
              <div class="col-sm-4">
                <span>Regi&oacute;n</span>
                <aph-custom-select
                  type="region"
                  [org]="user.Org.toString()"
                  [userId]="user.Id.toString()"
                  [filter]="organizationSelected.toString()"
                  placeholder="-- Seleccione una opción --"
                  (onSelectionChange)="getNodes()"
                  [disabled]="working"
                  (returnValue)="regionSelected = $event">
                </aph-custom-select>
              </div>
              <div class="col-sm-4">
                <span>Nodo</span>
                  <ng-autocomplete
                    [placeholder]="'Búsqueda'"
                    [disabled]="working"
                    [data]="nodesUser"
                    [searchKeyword]="inputKeyword"
                    [itemTemplate]="itemInputTemplate"
                    [notFoundTemplate]="notFoundinputTemplate"
                    [debounceTime]="600"
                    [minQueryLength]="3"
                    (selected)='changeNode($event)'
                    (inputCleared)="clearNode()"
                    [(ngModel)]="selectedNodeName"
                  >
                  </ng-autocomplete>
                  <ng-template #itemInputTemplate let-item>
                    <a [innerHTML]="item.UnitDescription"></a>
                  </ng-template>
                  <ng-template #notFoundinputTemplate let-notFound>
                    <div [innerHTML]="'No se encontraron coincidencias'"></div>
                  </ng-template>
              </div>
            </div>
            <div class="row filter-container">
              <div class="col-sm-6">
                <span>Tipo</span>

                <app-ceq-multiselect [Items]="typeList" 
                                (shareCheckedList)="onTypeFilterChange($event)"
                                (shareIndividualCheckedList)="ontypeItemCheckedChange($event)"
                               ></app-ceq-multiselect>
              </div>
              <div class="col-sm-6">
                <span>Equipo</span>
                <app-ceq-multiselect [Items]="itemsList" 
                (shareCheckedList)="onItemsFilterChange($event)"
                (shareIndividualCheckedList)="onItemsItemCheckedChange($event)"
               ></app-ceq-multiselect>
               
              </div>
            </div>

            <div class="row filter-container">
              <aph-custom-date-picker 
                [singleMode]="false" 
                labelInicio ="Desde"
                labelFin ="Hasta"
                [maxDate]="today"
                mode = "date"
                [IsDisabled]="working"
                [IsDisabledEnd]="working"
                [maxDaysLimit]="400"
                (startDateChange)="desde = $event"
                (endDateChange)="hasta = $event"
                (onValidationStatus)="esValido = $event" 
                class="col-md-12">
              </aph-custom-date-picker>
            </div>

            <br>
            <div class="row mt-3 col-lg-12 col-md-12">
              <!--Buttons-->
              <aph-custom-buttons 
                preset="excel" 
                label="Descargar reporte" 
                [loading]="downloading"
                [disabled]="!esValido"
                (btnClick)="download()">
              </aph-custom-buttons>
    
            </div>
          </div>
          </div>
        </div>
    </div>
  </div>
</div>


